export default {
  app: {
    golf: {
      title: 'Baneinformasjon',
      hasEVChargingPoint: 'Ladepunkt for elbil',
      hasCaddieService: 'Caddie-tjeneste',
      hasTrolley: 'Tralle',
      hasBuggy: 'Buggy',
      hasClubRental: 'Kølleutleie',
      hasAcademy: 'Akademi',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-sertifisering',
      hasTrainingArea: 'Treningsområde',
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hotell',
      hasDogsOnCourse: 'Hunder på banen',
      numberOfHoles: 'Antall hull',
    },
  },
};
